<template>
  <div class="container py-4">
    <div class="page-card">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0">Customers</h4>
        <div class="d-flex gap-2">
          <!-- <icon-button
            :func="() => showImport = true"
            :icon="'rotate-right'"
            :title="'Refresh'"
            :classes="'akkurate-green-btn btn-size'"
            :btnName="''"
          /> -->
          <icon-button
            :func="() => (showImport = true)"
            :icon="'upload'"
            :title="'Import CSV'"
            :classes="'akkurate-gray-btn btn-size2'"
            :btnName="'Import CSV'"
          />

          <icon-button
            :func="() => openCreate()"
            :icon="'plus'"
            :title="'Add customer'"
            :classes="'akkurate-green-btn btn-size2'"
            :btnName="'Add customer'"
          />
        </div>
      </div>

      <b-form-input
        v-model="search"
        class="mb-3 form-control"
        placeholder="Search customers..."
        @input="debouncedLoad"
      />

      <b-table
        :items="customers"
        :fields="fields"
        :busy="loading"
        responsive
        hover
        small
      >
        <template #cell(discountPercent)="data"> {{ data.value }}% </template>
        <template #cell(actions)="data">
          <icon-button
            :func="() => openEdit(data.item)"
            :icon="'eye'"
            :title="'Edit'"
            :classes="'akkurate-warning btn-sm'"
            :btnName="''"
          />
        </template>
      </b-table>
    </div>

    <b-modal
      v-model="showForm"
      :title="editingId ? 'Edit customer' : 'New customer'"
      @ok="save"
    >
      <b-form-group label="First name">
        <b-form-input class="form-control" v-model="form.firstName" />
      </b-form-group>
      <b-form-group label="Last name">
        <b-form-input class="form-control" v-model="form.lastName" />
      </b-form-group>
      <b-form-group label="Phone">
        <b-form-input class="form-control" v-model="form.phone" />
      </b-form-group>
      <b-form-group label="Email">
        <b-form-input class="form-control" v-model="form.email" type="email" />
      </b-form-group>
      <b-form-group label="Membership tier">
        <b-form-input
          class="form-control"
          v-model="form.membershipTier"
          placeholder="e.g. Gold"
        />
      </b-form-group>
      <b-form-group label="Member discount (%)">
        <b-form-input
          class="form-control"
          v-model="form.discountPercent"
          type="number"
          min="0"
          max="100"
          step="0.01"
        />
      </b-form-group>
      <b-form-group v-if="editingId" label="Loyalty points">
        <b-form-input
          class="form-control"
          v-model="form.loyaltyPoints"
          type="number"
          min="0"
          step="1"
        />
      </b-form-group>
      <b-form-group label="Notes">
        <b-form-textarea v-model="form.notes" rows="2" />
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <icon-button
          :func="() => cancel()"
          :icon="'times'"
          :title="'Cancel'"
          :classes="'akkurate-danger-bg btn-size2'"
          :btnName="'Cancel'"
        />

        <icon-button
          :func="() => ok()"
          :icon="'check'"
          :title="'Save'"
          :classes="'akkurate-green-btn btn-size2'"
          :btnName="'Save'"
        />
        <!-- <b-button variant="primary" @click="ok()">Save</b-button> -->
      </template>
    </b-modal>

    <bulk-import-modal
      v-model="showImport"
      title="Import customers"
      template-endpoint="import/customers/template"
      import-endpoint="import/customers"
      @imported="load"
    />
  </div>
</template>

<script>
import ApiService from "@/core/services/api.service";
import BulkImportModal from "@/views/main/pages/shared/BulkImportModal.vue";
import IconButton from "@/components/IconButton.vue";
import { icon } from "@fortawesome/fontawesome-svg-core";

export default {
  name: "Customers",
  components: { BulkImportModal, IconButton },
  data() {
    return {
      customers: [],
      loading: false,
      search: "",
      searchTimer: null,
      showForm: false,
      showImport: false,
      editingId: null,
      form: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        membershipTier: "",
        discountPercent: 0,
        loyaltyPoints: 0,
        notes: "",
      },
      fields: [
        { key: "fullName", label: "Name" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email" },
        { key: "loyaltyPoints", label: "Points" },
        { key: "membershipTier", label: "Tier" },
        { key: "discountPercent", label: "Discount" },
        { key: "actions", label: "" },
      ],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    debouncedLoad() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.load, 300);
    },
    async load() {
      this.loading = true;
      try {
        const params = { limit: 100 };
        if (this.search.trim()) params.query = this.search.trim();
        this.customers = await ApiService.get("customers", params);
      } finally {
        this.loading = false;
      }
    },
    openCreate() {
      this.editingId = null;
      this.form = {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        membershipTier: "",
        discountPercent: 0,
        loyaltyPoints: 0,
        notes: "",
      };
      this.showForm = true;
    },
    openEdit(customer) {
      this.editingId = customer.id;
      this.form = {
        firstName: customer.firstName || "",
        lastName: customer.lastName || "",
        phone: customer.phone || "",
        email: customer.email || "",
        membershipTier: customer.membershipTier || "",
        discountPercent: customer.discountPercent || 0,
        loyaltyPoints: customer.loyaltyPoints || 0,
        notes: customer.notes || "",
      };
      this.showForm = true;
    },
    async save(bvModalEvt) {
      bvModalEvt.preventDefault();
      try {
        if (this.editingId) {
          await ApiService.put(`customers/${this.editingId}`, {
            ...this.form,
            discountPercent: Number(this.form.discountPercent) || 0,
            loyaltyPoints: Number(this.form.loyaltyPoints) || 0,
          });
        } else {
          await ApiService.post("customers", {
            ...this.form,
            discountPercent: Number(this.form.discountPercent) || 0,
          });
        }
        this.showForm = false;
        await this.load();
        toast.fire({
          title: "Customer saved",
          icon: "success",
        });
      } catch (e) {
        toast.fire({
          title: e?.response?.data?.message || "Save failed",
          variant: "danger",
        });
      }
    },
  },
};
</script>
